import styled from 'styled-components';
import { Link } from 'edenred-ui';

export const BoldUnstyledLink = styled(Link)`
  text-decoration: none;
  font-weight: ${({ theme }) => theme.fontBold};
`;
